import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import axios from 'axios';

import { Endpoints, Mutations as RootMutations } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

import { Mutations, Actions } from './constants';

import ChannelListData from '@/ts/Channels/ChannelListData';

@Module({name: 'Channels', namespaced: true})
export default class Channels extends VuexModule {
    public joinedChannelList: ChannelListData[] = [];

    public availableChannelList: ChannelListData[] = [];

    // is used to display the name in the channel view before remaining data is fetched
    public selectedChannel: ChannelListData = null;

    get getJoinedChannelList() {
        return this.joinedChannelList;
    }

    get getAvailableChannelList() {
        return this.availableChannelList;
    }

    get getSelectedChannel() {
        return this.selectedChannel;
    }

    @Action
    public FETCH_JOINED_CHANNEL_LIST(data: any) {
        axios.get(Endpoints.Channels.USER_CHANNELS, {params: { joined: 1 }})
            .then((response) => {
                const channelList = response.data.data.map((channel) => new ChannelListData(channel.id, channel.name, channel.description, channel.conversationId));
                store.commit(Mutations.SET_JOINED_CHANNEL_LIST, channelList);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(RootMutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_AVAILABLE_CHANNEL_LIST(data: any) {
        axios.get(Endpoints.Channels.USER_CHANNELS, { params: { joined: 0 }})
            .then((response) => {
                const channelList = response.data.data.map((channel) => new ChannelListData(channel.id, channel.name, channel.description, channel.conversationId));
                store.commit(Mutations.SET_AVAILABLE_CHANNEL_LIST, channelList);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(RootMutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public JOIN_CHANNEL(channelId: string) {
        axios.post(Endpoints.Channels.JOIN_CHANNEL(channelId))
            .then(() => {
                store.dispatch(Actions.FETCH_AVAILABLE_CHANNEL_LIST);
                store.dispatch(Actions.FETCH_JOINED_CHANNEL_LIST);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(RootMutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public LEAVE_CHANNEL(channelId: string) {
        axios.post(Endpoints.Channels.LEAVE_CHANNEL(channelId))
            .then(() => {
                store.dispatch(Actions.FETCH_AVAILABLE_CHANNEL_LIST);
                store.dispatch(Actions.FETCH_JOINED_CHANNEL_LIST);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(RootMutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_JOINED_CHANNEL_LIST(data: ChannelListData[]): void {
        this.joinedChannelList = data;
    }

    @Mutation
    public SET_AVAILABLE_CHANNEL_LIST(data: ChannelListData[]): void {
        this.availableChannelList = data;
    }

    @Mutation
    public SET_SELECTED_CHANNEL(channel: ChannelListData): void {
        this.selectedChannel = channel;
    }
}

